const GenericPage = function() { this.init.apply(this, arguments); };

GenericPage.prototype = {
  id: null,
  name: null,
  icon: null,
  enabled: true,
  subPages: [],
  errors: [],

  init(name) { if (name) { this.name = name; } },

  getSubPages() { return this.subPages; },

  addSubPage(page) { this.subPages.push(page); },

  disable() { this.enabled = false; },

  enable() { this.enabled = true; },

  isEnabled() { return this.enabled; },

  isDisabled() { return !this.isEnabled(); },

  validate() { return true; },

  isValid() { return this.validate(); },

  setName(name) { this.name = name; }
};

export default GenericPage;
